import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import * as checkoutActions from '../../actions/checkout';
import { Service as ServiceType } from '../../reducers/checkout';

interface IAudioVideoCostModalProps extends RouteComponentProps {
  show: boolean
  onHide: () => void
}

const AudioVideoCostModal: React.FC<IAudioVideoCostModalProps> = props => {
  const dispatch = useDispatch();

  return (
    <Modal show={props.show} size="lg" onHide={props.onHide}>
      <Modal.Header closeButton />
      <Modal.Body className="p-5">
        <h3>Inmate Wallet -</h3>
        <h3>Voice & Video Calls Only</h3>
        <div className="row pt-3">        
            <span></span>
            <p>Our Reliance Tablet Phones and Reliance Tablet Stations allow for inmates to make voice and video calls—making communication more convenient and accessible for inmates and their friends and family. </p>
            <p className="font-weight-bold mb-0"><u>Cost of voice calls</u></p>
            <p><b>In State</b>  $0.09 - $0.25/minute + applicable taxes + Telecommunications Relay Service Fund (Rates vary depending on facility)</p>
            <p><b>State to State</b>  $0.09 - $0.21/minute + applicable taxes + Federal Universal Service Fund + Telecommunications Relay Service Fund (Rates vary depending on facility) </p>
            <p><b>International</b>  $0.80/minute + applicable taxes + Federal Universal Service Fund + Telecommunications Relay Service Fund </p>
            <p className="font-weight-bold mb-0"><u>Cost of video calls</u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
            <p><b></b>  $0.14 - $0.25/minute (Rates vary depending on facility)</p>
        </div>

        <button className="btn btn-lg btn-action btn-block mt-5" onClick={() => {
          props.onHide();
          dispatch(checkoutActions.selectService(ServiceType.AudioVideo));
          props.history.push('/checkout/audio-video');
        }}>
          Fund an Inmate Wallet - Voice & Video Calls Only account
        </button>
      </Modal.Body>
    </Modal>
  )
}

export default withRouter(AudioVideoCostModal);
